export const CONFIGURATION_PROVIDER_LABELS = {
	loadingErrorTitle: 'Configuration Loading Error'
};
